<template>
  <button
    :class="['v-btn', buttonSize, buttonVariant, buttonBlock, buttonPill]"
    :type="type"
    @click="clicked"
  >
    <slot />
  </button>
</template>

<script>
const types = Object.freeze({
  BUTTON: "button",
  SUBMIT: "submit"
});

const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
});

const variants = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
  INFO: "info",
  LIGHT: "light",
  CARD: "card",
  LINK: "link",
  NEUTRAL: "neutral"
});

export default {
  name: "BaseButton",
  props: {
    type: {
      type: String,
      validator: value => Object.values(types).includes(value),
      default: types.BUTTON
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    variant: {
      type: String,
      validator: value => Object.values(variants).includes(value),
      default: variants.PRIMARY
    },
    outline: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked() {
      this.$emit("click");
    }
  },
  computed: {
    buttonSize() {
      return `v-btn-${this.size}`;
    },
    buttonVariant() {
      return this.outline
        ? `v-btn-outline-${this.variant}`
        : `v-btn-${this.variant}`;
    },
    buttonBlock() {
      return this.block && `v-btn-block`;
    },
    buttonPill() {
      return this.pill && `v-btn-pill`;
    }
  }
};
</script>
